/**
 * External Links Dialog
 */
const $ = window.jQuery;

export class SiteSearch {
  constructor() {
    this.form();
  }

  form() {
    $(document).on("submit", `.search-form`, (event) => {
      event.preventDefault();

      let terms = $(".search-input").val();
      terms = encodeURIComponent(terms);

      location.href = `/search/${terms}/`;
    });
  }
}
